import { app } from '../../../../bootstrap/core';
import { shiptmentStatusComponent } from './shipmentStatus.component';

app.component(shiptmentStatusComponent.name, shiptmentStatusComponent);



// WEBPACK FOOTER //
// ./src/app/components/status/components/shipmentStatus/shipmentStatus.js